<template>
  <div class="d-flex flex-column mb-3" :key="customKey">
    <div class="d-flex">
      <DatePicker
        ref="datePicker"
        v-model="data.startDate"
        placeholder="Select date"
        type="date"
        style="width: 200px;"
        @on-change="$emit('onChangeDates')"
        format="dd-MM-yyyy"
        clearable
        editable
        :options="dateOptions"
        @keydown.tab="handleBlur"
      ></DatePicker>
      <span class="ml-1 mr-1"> - </span>
      <TimePicker
        ref="timePicker"
        v-model="data.startHour"
        type="time"
        :value="valueTimePicker"
        format="HH:mm"
        editable
        style="width: 112px;"
        placeholder="Select time"
        @on-change="$emit('onChangeHours')"
        clearable
        @keydown.tab="handleBlur"
      ></TimePicker>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompetitionDateHour",
  props: [
    "data",
    "valueTimePicker",
    "index",
    "customKey",
    "stageKey",
    "formItemDate"
  ],

  data() {
    return {
      dateOptions: {},
      editor: null
    };
  },

  methods: {
    handleBlur(event) {
      this.$nextTick(() => {
        const target = event.target;
        const pickerRef = target === this.$refs.datePicker ? 'onChangeDates' : 'onChangeHours';
        this.$emit(pickerRef);
      });
    }
  },

  watch: {
    formItemDate(date) {
      if (this.stageKey !== "stage") {
        this.dateOptions = {
          disabledDate(opt) {
            let date1 = new Date(date[0]);
            if (date1) {
              let closedRegistered = new Date(
                date1.setDate(date1.getDate() - 2)
              );
              return opt && opt > closedRegistered.valueOf();
            }
          }
        };
      }
    }
  },

  mounted() {
    if (this.stageKey === "stage") {
      if (this.data.date_start) {
        const dateStart = new Date(this.data.date_start);
        let startHours = dateStart.getHours();
        let startMinutes = dateStart.getMinutes();

        this.data.startDate = new Date(this.data.date_start);
        this.data.startHour = startHours + ":" + startMinutes;
      }

      if (this.formItemDate.length > 0) {
        const date1 = new Date(this.formItemDate[0]);
        const date2 = new Date(this.formItemDate[1]);

        this.dateOptions = {
          disabledDate(opt) {
            return opt < date1.valueOf() || opt > date2.valueOf();
          }
        };
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/competitions/utils/CompetitionDateHour.vue